const action = {
    general: 'هنگام اجرای عملیات خطایی رخ داد. لطفاً بعداً تلاش کنید.',
    sign_in_identifier_changed: 'عملیات نمی‌تواند شناسه ورود استفاده‌شده در این تأیید را تغییر دهد.',
};
export default Object.freeze(action);
